const SMILY_SVG = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 77 31">
  <rect width="77" height="31" fill="#022d94" rx="4"/>
  <path fill="#fff" d="m13.257 11.175 1.987.145c5.306.388 6.493 1.066 5.597 5.234-.63 3.005-1.14 5.96-9.135 5.96-4.628 0-7.68-.096-6.42-6.057h4.651c-.412 1.89.243 2.084 2.617 2.084 2.278 0 3.053-.146 3.368-1.672.34-1.575.073-1.55-2.18-1.696l-1.043-.073c-4.41-.315-7.05-.29-5.936-5.5 1.115-5.21 4.12-5.549 8.868-5.549 3.974 0 7.342.073 6.276 5.089l-.17.75h-4.652c.412-1.865-.363-1.865-2.302-1.865-2.617 0-2.956.533-3.174 1.55-.315 1.455.388 1.503 1.648 1.6m11.335-1.526h4.046l-.387 1.793h.17c.823-1.503 2.47-1.939 3.9-1.939 1.793 0 3.562.315 3.32 2.496h.194c.605-1.817 2.471-2.496 4.07-2.496 2.932 0 4.168 1.212 3.538 4.168L41.6 22.369h-4.167l1.575-7.366c.194-1.332.436-2.302-1.188-2.302s-2.18 1.09-2.471 2.448l-1.526 7.22h-4.168l1.648-7.705c.193-1.163.29-1.963-1.163-1.963-1.72 0-2.23.921-2.569 2.448l-1.526 7.22h-4.168zm26.306 0-2.713 12.72h-4.168l2.714-12.72zm1.14-5.452-.68 3.198h-4.167l.679-3.198zm6.61 0-3.853 18.172h-4.167L54.48 4.197zM72 9.649l-6.154 13.835c-1.406 3.343-2.908 4.53-6.445 4.53-.485 0-.921-.048-1.406-.072l.606-2.883c.242.024.485.048.727.048 1.744 0 2.374-1.284 2.762-2.738h-2.278L58.747 9.65h4.362l.315 10.346h.048L67.737 9.65z"/>
  <path fill="#ffbb1c" d="M52.48 5.812a2.827 2.827 0 1 1-5.653 0 2.827 2.827 0 0 1 5.653 0"/>
</svg>`;

const ICON_UNLOCK_SVG = `<svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.86328 0.711467C6.67932 0.711467 5.71875 1.66787 5.71875 2.84669V4.27018H7.14844C7.937 4.27018 8.57812 4.90852 8.57812 5.69366V10.6759C8.57812 11.461 7.937 12.0993 7.14844 12.0993H1.42969C0.641126 12.0993 0 11.461 0 10.6759V5.69366C0 4.90852 0.641126 4.27018 1.42969 4.27018H5.00391V2.84669C5.00391 1.27419 6.28392 -0.000274658 7.86328 -0.000274658C9.44264 -0.000274658 10.7227 1.27419 10.7227 2.84669V3.9143C10.7227 4.11003 10.5618 4.27018 10.3652 4.27018C10.1687 4.27018 10.0078 4.11003 10.0078 3.9143V2.84669C10.0078 1.66787 9.04724 0.711467 7.86328 0.711467ZM7.14844 4.98192H1.42969C1.03429 4.98192 0.714844 5.29998 0.714844 5.69366V10.6759C0.714844 11.0695 1.03429 11.3876 1.42969 11.3876H7.14844C7.54384 11.3876 7.86328 11.0695 7.86328 10.6759V5.69366C7.86328 5.29998 7.54384 4.98192 7.14844 4.98192ZM5.36133 8.54063H3.2168C3.02021 8.54063 2.85938 8.38048 2.85938 8.18476C2.85938 7.98903 3.02021 7.82888 3.2168 7.82888H5.36133C5.55791 7.82888 5.71875 7.98903 5.71875 8.18476C5.71875 8.38048 5.55791 8.54063 5.36133 8.54063Z" fill="currentColor"/></svg>`;

const ICON_LOCK_SVG = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.49619 10.93C7.67814 10.93 7.82614 10.782 7.82614 10.6001V9.48828L7.84634 9.47328C7.99844 9.36058 8.08564 9.18808 8.08564 8.99998C8.08564 8.67498 7.82124 8.41058 7.49619 8.41058C7.17114 8.41058 6.90674 8.67498 6.90674 8.99998C6.90674 9.18808 6.99394 9.36058 7.14604 9.47328L7.16624 9.48828V10.6001C7.16624 10.782 7.31424 10.93 7.49619 10.93Z" fill="currentColor"/><path d="M5.30866 7.36615C4.44951 7.36615 3.75061 8.0651 3.75061 8.9242C3.75061 9.0665 3.86631 9.1822 4.00861 9.1822C4.15091 9.1822 4.26661 9.0665 4.26661 8.9242C4.26661 8.34965 4.73411 7.88215 5.30866 7.88215C5.45096 7.88215 5.56666 7.76645 5.56666 7.62415C5.56666 7.48185 5.45096 7.36615 5.30866 7.36615Z" fill="currentColor"/><path d="M12.5749 7.86453C12.5749 6.90393 11.7937 6.10218 10.8334 6.07693L10.7983 6.07653C10.7918 6.07623 10.7853 6.07593 10.7786 6.07593H10.3791V4.58228C10.3791 2.99258 9.08583 1.69928 7.49618 1.69928C5.90653 1.69928 4.61323 2.99258 4.61323 4.58228V6.07593H4.21373C3.22733 6.07593 2.42493 6.87838 2.42493 7.86468V11.5119C2.42493 12.4983 3.22738 13.3007 4.21373 13.3007L10.7861 13.3005C11.7725 13.3005 12.5749 12.498 12.5749 11.5117V7.86453ZM5.27308 4.58228C5.27308 3.35643 6.27033 2.35918 7.49618 2.35918C8.72203 2.35918 9.71928 3.35643 9.71928 4.58228V6.07593H5.27308V4.58228ZM11.915 11.5117C11.915 12.1342 11.4086 12.6407 10.7861 12.6407L6.40953 12.6409H4.21373C3.59128 12.6409 3.08483 12.1344 3.08483 11.5119V7.86473C3.08483 7.24228 3.59128 6.73583 4.21373 6.73583L10.7916 6.73593C11.4114 6.73938 11.9151 7.24568 11.9151 7.86453V11.5117H11.915Z" fill="currentColor"/></svg>`;

const LEVEL_MAP = [
    { level: 1, label: '0,25 Punkte je 1 € Jahresbeitrag'},
    { level: 2, label: '0,5 Punkte je 1 € Jahresbeitrag'},
    { level: 3, label: '0,75 Punkte je 1 € Jahresbeitrag'}
];

function escapeAttr(value) {
    return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
}

class SmilyTeaser extends HTMLElement {
    static get observedAttributes() {
        return ['level', 'no-update', 'api-url'];
    }

    connectedCallback() {
        this.apiUrl = this.getAttribute('api-url');
        this.noUpdate = this.hasAttribute('no-update');
        this.data = {};

        if (this.noUpdate || !this.apiUrl) {
            this.render(this.innerHTML, '');
            return;
        }

        this.renderLoading();
        this.fetchData().then(isSuccessfulFetch => {
            if (!isSuccessfulFetch) {
                this.dispatchEvent(new CustomEvent('smily-error-loading', {
                    bubbles: true,
                    detail: {
                        error: 'Error fetching smily api data',
                    }
                }));
                return;
            }
            this.renderLevels();
            this.dispatchEvent(new CustomEvent('smily-data-loaded', {
                bubbles: true,
                detail: {
                    data: this.data
                }
            }));
        });
    }

    async fetchData() {
        try {
            const response = await fetch(this.apiUrl, { credentials: 'include' });
            if (!response.ok) {
                this.renderError();
                return false;
            }
            this.data = await response.json();
            return true;
        } catch (err) {
            this.renderError();
            return false;
        }
    }

    get level() {
        const val = this.data?.level ?? this.hasAttribute('level');
        return val === null || val === '' || val === false ? null : parseInt(val, 10);
    }

    get onboardingUrl() {
        return this.getAttribute('onboarding-url');
    }

    get isLoggedIn() {
        return this.hasAttribute('logged-in');
    }

    // =========================================================================
    // RENDERING
    // =========================================================================
    renderLoading() {
        if (!this.isLoggedIn) {
            return;
        }
        this.innerHTML = `<div class="smily-loading"></div>`;
    }

    renderError() {
        this.innerHTML = `<div class="smily-error"></div>`;
    }

    renderLevels() {
        const level = this.level;
        const levels = LEVEL_MAP.map(levelItem => {
            const unlocked = level >= levelItem.level;
            const iconSvg = unlocked ? ICON_UNLOCK_SVG : ICON_LOCK_SVG;
            return `
            <div class="smily-teaser__level${unlocked ? ' smily-teaser__level--unlocked' : ''}">
                <span class="smily-teaser__level-badge">
                    <span class="smily-teaser__level-icon">${iconSvg}</span>&nbsp;Level&nbsp;${levelItem.level}
                </span>
                <span class="smily-teaser__level-text">
                    ${levelItem.label}
                </span>
            </div>`;
        }).join('');

        const content = `
            <div class="smily-teaser__text">
                Sofortiger <b>Zugang zu unserem Smily-Treueprogramm</b> und Punkten <b>beim Abschluss Ihrer Tierkrankenversicherung.</b>
            </div>
            <div class="smily-teaser__levels">
                ${levels}
            </div>`;

        this.render(content);
    }

    render(content) {
        let htmlTag = 'div';
        if (this.isLoggedIn) {
            htmlTag = 'a';
        }

        this.innerHTML = `
            <${htmlTag} class="smily-teaser" ${this.isLoggedIn ? 'href="https://smily.check24.de/benefits"' : ''}>
                <div class="smily-teaser__header">
                    <span>
                        Belohnen Sie sich mit <span class="smily-teaser__hilite">exklusiven Vorteilen</span>
                    </span>
                    <img src="data:image/svg+xml,${encodeURIComponent(SMILY_SVG)}" class="smily-teaser__logo" alt="Smily" />
                </div>
                ${content}
            </${htmlTag}>`;
    }
}

customElements.define('smily-teaser', SmilyTeaser);
